package org.teddapp.project.ui.projects

import org.teddapp.project.ui.teddClickable
import org.teddapp.project.ui.TeddMenuEntry
import org.teddapp.project.ui.TeddMenu
import org.teddapp.project.ui.teddCardShadow

import org.teddapp.project.ui.TeddFineProgress

import org.teddapp.project.ui.TeddTag
import org.teddapp.project.ui.TeddTagTone

import org.teddapp.project.ui.TeddTabs

import org.teddapp.project.ui.TeddTab

import org.teddapp.project.ui.TeddScreenHeader

import org.teddapp.project.ui.TeddFilterRow

import org.teddapp.project.ui.TeddSize

import org.teddapp.project.ui.TeddSpace

import androidx.compose.foundation.layout.widthIn

import androidx.compose.ui.text.style.TextOverflow

import org.teddapp.project.ui.LocalTeddFonts

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInHorizontally
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutHorizontally
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.hoverable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.ReadOnlyComposable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Rect
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.input.pointer.positionChange
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.layout.positionInRoot
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.tedd.db.Organization
import com.tedd.db.Project
import com.tedd.db.ProjectStatus
import com.tedd.db.Skill
import com.tedd.db.Task
import kotlin.math.roundToInt
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.launch
import org.teddapp.project.db.ParentKind
import org.teddapp.project.db.TeddRepositories
import org.teddapp.project.ui.ChipSize
import org.teddapp.project.ui.ChipTone
import org.teddapp.project.ui.TeddButton
import org.teddapp.project.ui.TeddButtonKind
import org.teddapp.project.ui.TeddButtonSize
import org.teddapp.project.ui.TeddChip
import org.teddapp.project.ui.TeddIcon
import org.teddapp.project.ui.TeddIconButton
import org.teddapp.project.ui.TeddLogo
import org.teddapp.project.ui.TeddType
import org.teddapp.project.ui.TeddTokens
import org.teddapp.project.ui.nav.Section
import org.teddapp.project.ui.TeddDates
import org.teddapp.project.ui.TeddDateField
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.type
import org.teddapp.project.ui.teddSurface
import org.teddapp.project.ui.TeddCheckbox
import org.teddapp.project.ui.TeddCheckboxRow
import org.teddapp.project.ui.TeddEmptyState
import androidx.compose.foundation.layout.PaddingValues

// ──────────────────────────────────────────────────────────────────────
// Parties propres à la mise en page étendue : barre latérale, kanban avec
// glisser-déposer, liste, panneau de détail, états de formulaire.
// ──────────────────────────────────────────────────────────────────────

// ──────────────────────────────────────────────────────────────────────
// Sidebar : Organisations + Projets
// ──────────────────────────────────────────────────────────────────────
/** Form state pour les modals Org/Project. */
internal sealed interface OrgFormMode {
    data object New : OrgFormMode
    data class Edit(val org: Organization) : OrgFormMode
}

internal sealed interface ProjectFormMode {
    data class New(val organizationId: String) : ProjectFormMode
    data class Edit(val project: Project) : ProjectFormMode
}

/**
 * Colonne des projets. Chaque organisation est un petit titre ; sous lui, ses projets,
 * chacun avec son avancement. On voit d'un coup d'œil où en est chaque projet sans l'ouvrir.
 */
/** La liste des projets : 272 dp par défaut, de 220 à 440. */
private val PROJECTS_PANE = org.teddapp.project.ui.PaneSpec("projects.list", default = 272.dp, min = 220.dp, max = 440.dp)

@Composable
internal fun ProjectsSidebar(
    organizations: List<Organization>,
    projects: List<Project>,
    selectedProjectId: String?,
    expandedOrgs: Set<String>,
    onToggleOrg: (String) -> Unit,
    onSelectProject: (String) -> Unit,
    onOpenManager: () -> Unit,
    onNewProject: (orgId: String) -> Unit,
    repos: TeddRepositories,
) {
    var search by remember { mutableStateOf("") }
    val q = search.trim()
    // Le filet du bord est la poignée : on y règle la largeur de la colonne.
    org.teddapp.project.ui.TeddSidePane(
        spec = PROJECTS_PANE,
        collapsedContent = { expand ->
            org.teddapp.project.ui.TeddPaneRail(
                expand = expand,
                title = "la liste des projets",
                items = projects.map { p -> org.teddapp.project.ui.PaneRailItem(p.id, p.name, p.icon, p.id == selectedProjectId) { onSelectProject(p.id) } },
            )
        },
    ) {
    Row(Modifier.fillMaxSize()) {
        Column(modifier = Modifier.weight(1f).fillMaxHeight()) {
            Column(
                modifier = Modifier.padding(bottom = TeddSpace.S2),
                verticalArrangement = Arrangement.spacedBy(TeddSpace.S3),
            ) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Column(modifier = Modifier.weight(1f).padding(start = TeddSpace.S1)) {
                        Text("Projets", color = TeddTokens.Ink, style = TeddType.BodyStrong)
                        Text(
                            "${projects.size} projet${if (projects.size > 1) "s" else ""}",
                            color = TeddTokens.InkMuted,
                            style = TeddType.MonoSm.copy(fontSize = 11.sp),
                        )
                    }
                    organizations.firstOrNull()?.let { first ->
                        TeddButton(
                            text = "Projet",
                            onClick = { onNewProject(projects.firstOrNull { it.id == selectedProjectId }?.organization_id ?: first.id) },
                            kind = TeddButtonKind.Secondary,
                            size = TeddButtonSize.Sm,
                            icon = "plus",
                        )
                    }
                }
                // La recherche n'apparaît que lorsqu'il y a de quoi chercher.
                if (projects.size > 6) {
                    val shape = RoundedCornerShape(TeddTokens.RSm)
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(TeddSize.ControlSm)
                            .background(TeddTokens.Surface, shape)
                            .border(1.dp, TeddTokens.Line, shape)
                            .padding(horizontal = 10.dp),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2),
                    ) {
                        TeddIcon(name = "search", size = 14.dp, color = TeddTokens.InkMuted)
                        BasicTextField(
                            value = search,
                            onValueChange = { search = it },
                            singleLine = true,
                            modifier = Modifier.weight(1f),
                            textStyle = TeddType.Body.copy(color = TeddTokens.Ink),
                            cursorBrush = SolidColor(TeddTokens.Ink),
                            decorationBox = { inner ->
                                if (search.isEmpty()) Text("Trouver un projet…", color = TeddTokens.InkSubtle, style = TeddType.Body)
                                inner()
                            },
                        )
                    }
                }
            }
            Column(
                modifier = Modifier
                    .weight(1f)
                    .verticalScroll(rememberScrollState())
                    .padding(horizontal = TeddSpace.S3, vertical = TeddSpace.S1),
                verticalArrangement = Arrangement.spacedBy(TeddSpace.S4),
            ) {
                organizations.forEach { org ->
                    val color = runCatching { Color(parseHexProj(org.color)) }.getOrElse { TeddTokens.InkMuted }
                    val orgProjects = projects.filter { it.organization_id == org.id && (q.isEmpty() || it.name.contains(q, ignoreCase = true)) }
                    if (q.isNotEmpty() && orgProjects.isEmpty()) return@forEach
                    val expanded = org.id in expandedOrgs || q.isNotEmpty()
                    Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
                        OrgSidebarRow(
                            org = org,
                            color = color,
                            expanded = expanded,
                            projectCount = orgProjects.size,
                            onToggle = { onToggleOrg(org.id) },
                            onNewProject = { onNewProject(org.id) },
                        )
                        if (expanded) {
                            orgProjects.forEach { proj ->
                                ProjectSidebarItem(
                                    project = proj,
                                    isSelected = proj.id == selectedProjectId,
                                    repos = repos,
                                    onClick = { onSelectProject(proj.id) },
                                )
                            }
                            if (orgProjects.isEmpty()) {
                                Text(
                                    "Aucun projet ici.",
                                    color = TeddTokens.InkSubtle,
                                    style = TeddType.Caption,
                                    modifier = Modifier.padding(start = TeddSpace.S3, top = 2.dp, bottom = 2.dp),
                                )
                            }
                        }
                    }
                }
                if (organizations.isEmpty()) {
                    Text(
                        "Un projet appartient à une organisation : un client, une équipe, toi-même. Crée la première.",
                        color = TeddTokens.InkMuted,
                        style = TeddType.Caption,
                        modifier = Modifier.padding(horizontal = TeddSpace.S2),
                    )
                }
            }
            Box(Modifier.fillMaxWidth().height(1.dp).background(TeddTokens.Line))
            TeddButton(
                text = "Gérer les organisations",
                onClick = onOpenManager,
                kind = TeddButtonKind.Ghost,
                size = TeddButtonSize.Sm,
                icon = "settings",
                modifier = Modifier.padding(horizontal = TeddSpace.S3, vertical = TeddSpace.S2),
            )
        }
    }
    }
}

/** Titre d'une organisation : sa pastille, son nom, et « + » pour y ajouter un projet. Cliquer replie. */
@Composable
internal fun OrgSidebarRow(
    org: Organization,
    color: Color,
    expanded: Boolean,
    projectCount: Int,
    onToggle: () -> Unit,
    onNewProject: (() -> Unit)? = null,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .teddClickable(onClick = onToggle, role = null)
            .height(30.dp)
            .padding(start = TeddSpace.S3, end = 2.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2),
    ) {
        // La couleur de l'organisation est une donnée de l'utilisateur : une pastille.
        Box(Modifier.size(8.dp).background(color, CircleShape))
        Text(
            text = org.name.uppercase(),
            color = TeddTokens.InkMuted,
            style = TeddType.Overline,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
        )
        if (!expanded) Text("$projectCount", color = TeddTokens.InkSubtle, style = TeddType.MonoSm.copy(fontSize = 11.sp))
        TeddIcon(name = if (expanded) "chevron-down" else "chevron-right", size = 12.dp, color = TeddTokens.InkSubtle)
        Spacer(modifier = Modifier.weight(1f))
        if (onNewProject != null) {
            TeddIconButton(onClick = onNewProject, size = 26.dp) {
                TeddIcon(name = "plus", size = 14.dp, color = TeddTokens.InkMuted)
            }
        }
    }
}

/**
 * Un projet dans la colonne : son nom, puis son avancement en une ligne. Celui qu'on a
 * ouvert se pose sur la surface.
 */
@Composable
internal fun ProjectSidebarItem(
    project: Project,
    isSelected: Boolean,
    repos: TeddRepositories,
    onClick: () -> Unit,
) {
    val tasks by repos.tasks.observeByProject(project.id).collectAsState(emptyList())
    val statuses by repos.projectStatus.observeByProject(project.id).collectAsState(emptyList())
    val health = remember(tasks, statuses) { computeProjectHealth(tasks, statuses) }
    val total = tasks.size
    val done = total - health.open
    val tint = runCatching { Color(parseHexProj(project.color)) }.getOrElse { TeddTokens.ModGoals }
    val shape = RoundedCornerShape(TeddTokens.RMd)
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .then(if (isSelected) Modifier.teddCardShadow(shape) else Modifier)
            .teddClickable(
                onClick = onClick,
                shape = shape,
                fill = if (isSelected) TeddTokens.Surface else Color.Transparent,
                hover = if (isSelected) TeddTokens.Surface else TeddTokens.SurfaceSunken,
                role = null,
            )
            .padding(horizontal = TeddSpace.S3, vertical = 10.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(TeddSpace.S3),
    ) {
        Box(
            modifier = Modifier.size(32.dp).background(if (isSelected) TeddTokens.SurfaceSunken else TeddTokens.Surface, RoundedCornerShape(TeddTokens.RSm)),
            contentAlignment = Alignment.Center,
        ) {
            TeddIcon(name = project.icon, size = 16.dp, color = tint)
        }
        Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(5.dp)) {
            Text(
                text = project.name,
                color = TeddTokens.Ink,
                style = TeddType.Label.copy(fontSize = 14.sp, fontWeight = FontWeight(if (isSelected) 600 else 500)),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
            if (total > 0) TeddFineProgress(fraction = done.toFloat() / total, height = 4.dp)
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                Text(
                    text = if (total == 0) "Aucune tâche" else "$done sur $total",
                    color = TeddTokens.InkMuted,
                    style = TeddType.MonoSm.copy(fontSize = 11.sp),
                )
                if (health.overdue > 0) {
                    TeddIcon(name = "alert", size = 11.dp, color = TeddTokens.Warning)
                    Text("${health.overdue} en retard", color = TeddTokens.Warning, style = TeddType.Caption.copy(fontSize = 11.sp))
                }
            }
        }
    }
}

// ──────────────────────────────────────────────────────────────────────
// Project main : header + Kanban
// ──────────────────────────────────────────────────────────────────────
enum class ProjectView { Kanban, List }

internal sealed interface StatusFormMode {
    data object New : StatusFormMode
    data class Edit(val status: ProjectStatus) : StatusFormMode
}

@Composable
internal fun ProjectMain(
    project: Project,
    org: Organization?,
    repos: TeddRepositories,
    view: ProjectView,
    onViewChange: (ProjectView) -> Unit,
    onOpenTask: (String) -> Unit,
    onNewStatus: () -> Unit,
    onEditStatus: (ProjectStatus) -> Unit,
    onDeleteStatus: (ProjectStatus) -> Unit,
    onEditProject: () -> Unit,
    onDeleteProject: () -> Unit,
    dragState: KanbanDragState,
    onSendToFocus: ((Task) -> Unit)? = null,
    skills: List<Skill> = emptyList(),
    onOpenSkill: ((String) -> Unit)? = null,
) {
    val projectColor = runCatching { Color(parseHexProj(project.color)) }.getOrElse { TeddTokens.LimeStrong }
    val statuses by repos.projectStatus.observeByProject(project.id).collectAsState(emptyList())
    val tasks by repos.tasks.observeByProject(project.id).collectAsState(emptyList())
    val orgColor = org?.let { runCatching { Color(parseHexProj(it.color)) }.getOrNull() }

    val scope = rememberCoroutineScope()

    Column(modifier = Modifier.fillMaxSize()) {
        // En-tête : fil d'Ariane, titre et actions, puis la progression du projet.
        val terminalIds = remember(statuses) { statuses.filter { it.is_terminal == 1L }.map { it.id }.toSet() }
        // « Faite » : rangée dans une colonne terminale, ou cochée ailleurs dans l'application.
        val doneCount = tasks.count { it.status == "done" || (it.status_id != null && it.status_id in terminalIds) }
        val progress = if (tasks.isNotEmpty()) doneCount.toFloat() / tasks.size else 0f
        val attached = skills.firstOrNull { it.id == project.skill_id }
        val health = remember(tasks, statuses) { computeProjectHealth(tasks, statuses) }
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(start = TeddSpace.S8, end = TeddSpace.S8, top = TeddSpace.S5, bottom = TeddSpace.S2),
            verticalArrangement = Arrangement.spacedBy(TeddSpace.S4),
        ) {
            // Une ligne : le nom, la vue, et un seul menu pour ce qu'on fait rarement.
            TeddScreenHeader(
                title = project.name,
                overline = org?.name,
                subtitle = project.objectives?.takeIf { it.isNotBlank() },
            ) {
                ProjectViewToggle(value = view, onChange = onViewChange)
                ProjectMoreMenu(
                    listOf(
                        MenuAction("Modifier le projet", "edit", onEditProject),
                        MenuAction("Nouvelle colonne", "plus", onNewStatus),
                        MenuAction("Supprimer le projet", "trash", onDeleteProject, danger = true),
                    ),
                )
            }
            // Où en est le projet, en une ligne : l'avancement, puis seulement ce qui demande attention.
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(TeddSpace.S3)) {
                TeddFineProgress(fraction = progress, modifier = Modifier.width(160.dp), height = 6.dp)
                Text(
                    text = if (tasks.isEmpty()) "Aucune tâche" else "$doneCount sur ${tasks.size} faite${if (tasks.size > 1) "s" else ""}",
                    color = TeddTokens.InkMuted,
                    style = TeddType.MonoSm,
                )
                if (health.overdue > 0) TeddTag("${health.overdue} en retard", tone = TeddTagTone.Warning, icon = "alert")
                if (health.stalled) TeddTag("Rien n'a bougé depuis ${health.stalest} j", icon = "clock")
                Spacer(modifier = Modifier.weight(1f))
                ProjectSkillTag(
                    skill = attached,
                    onClick = if (attached != null && onOpenSkill != null) { { onOpenSkill(attached.id) } } else onEditProject,
                )
            }
            health.nextAction?.let { NextActionBar(it, onOpenTask, onSendToFocus) }
        }
        when (view) {
            ProjectView.Kanban -> KanbanBoard(
                project = project,
                statuses = statuses,
                tasks = tasks,
                repos = repos,
                onOpenTask = onOpenTask,
                onNewStatus = onNewStatus,
                onEditStatus = onEditStatus,
                onDeleteStatus = onDeleteStatus,
                dragState = dragState,
            )
            ProjectView.List -> ProjectListView(
                statuses = statuses,
                tasks = tasks,
                repos = repos,
                onOpenTask = onOpenTask,
                projectId = project.id,
            )
        }
    }
}

/** La prochaine tâche à faire, sur une ligne : on la lance ou on l'ouvre sans chercher dans le tableau. */
@Composable
private fun NextActionBar(task: Task, onOpenTask: (String) -> Unit, onSendToFocus: ((Task) -> Unit)?) {
    val shape = RoundedCornerShape(TeddTokens.RMd)
    val late = !task.due_date.isNullOrBlank() && task.due_date!! < TeddDates.todayIso
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .teddSurface(shape)
            .teddClickable(onClick = { onOpenTask(task.id) }, shape = shape, role = null)
            .padding(start = TeddSpace.S4, end = TeddSpace.S2, top = TeddSpace.S2, bottom = TeddSpace.S2),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(TeddSpace.S3),
    ) {
        Text("À FAIRE ENSUITE", color = TeddTokens.InkMuted, style = TeddType.Overline)
        Text(
            text = task.title,
            color = TeddTokens.Ink,
            style = TeddType.BodyStrong,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.weight(1f),
        )
        task.due_date?.takeIf { it.isNotBlank() }?.let { due ->
            TeddTag(
                text = (TeddDates.formatRelative(due) ?: due) + if (late) " · en retard" else "",
                tone = if (late) TeddTagTone.Warning else TeddTagTone.Neutral,
                icon = "calendar",
            )
        }
        task.estimated_minutes?.let { Text("$it min", color = TeddTokens.InkMuted, style = TeddType.MonoSm) }
        if (onSendToFocus != null) {
            TeddButton(
                text = "Faire maintenant",
                onClick = { onSendToFocus(task) },
                kind = TeddButtonKind.Primary,
                size = TeddButtonSize.Sm,
                icon = "focus",
            )
        }
    }
}

internal class MenuAction(val label: String, val icon: String, val onClick: () -> Unit, val danger: Boolean = false)

/** Le menu « … » : les gestes rares (renommer, supprimer, ajouter une colonne) y sont rangés. */
@Composable
internal fun ProjectMoreMenu(actions: List<MenuAction>, size: androidx.compose.ui.unit.Dp = 32.dp) {
    var open by remember { mutableStateOf(false) }
    Box {
        TeddIconButton(onClick = { open = true }, size = size, active = open) {
            TeddIcon(name = "more", size = 16.dp, color = TeddTokens.InkMuted)
        }
        TeddMenu(
            expanded = open,
            onDismiss = { open = false },
            width = 240.dp,
            alignEnd = true,
            entries = actions.map { a -> TeddMenuEntry(a.label, icon = a.icon, danger = a.danger, onClick = a.onClick) },
        )
    }
}

@Composable
internal fun ProjectViewToggle(value: ProjectView, onChange: (ProjectView) -> Unit) {
    TeddTabs(
        tabs = listOf(
            TeddTab(ProjectView.Kanban.name, "Tableau", icon = "grid"),
            TeddTab(ProjectView.List.name, "Liste", icon = "list"),
        ),
        selected = value.name,
        onSelect = { name -> ProjectView.entries.firstOrNull { it.name == name }?.let(onChange) },
    )
}

/**
 * État DnD partagé entre les cards (sources), les colonnes (targets), et le ghost overlay.
 *
 * - `draggingTaskId` : id de la card en cours de drag (null si rien).
 * - `dragOffsetGlobal` : position globale (root coords) du curseur pendant le drag.
 * - `columnRects` : rect global de chaque colonne, mis à jour via `onGloballyPositioned`.
 * - `hoverColumnId` : colonne survolée (dérivé de dragOffsetGlobal + columnRects).
 *
 * NB : on ne stocke pas de `dragVisualOffset` — l'original ne bouge pas (sinon les
 * coords locales du pointerInput se figent et le hit-test casse). À la place, un
 * ghost overlay positionné via `Modifier.offset` suit le curseur.
 */
internal class KanbanDragState {
    var draggingTaskId by mutableStateOf<String?>(null)
    var dragOffsetGlobal by mutableStateOf(Offset.Zero)
    val columnRects = mutableStateMapOf<String, Rect>()
    /** Rect global de chaque card (par taskId), pour calculer la position d'insertion. */
    val taskRects = mutableStateMapOf<String, Rect>()
    /** Map taskId → statusId du parent, pour limiter le hit-test au bon column. */
    val taskStatusOf = mutableStateMapOf<String, String>()
    val hoverColumnId by derivedStateOf {
        if (draggingTaskId == null) null
        else columnRects.entries.firstOrNull { it.value.contains(dragOffsetGlobal) }?.key
    }
    /**
     * Position d'insertion dans la colonne survolée. Compte le nombre de cards
     * dont le CENTRE Y est au-dessus du curseur. Exclut la card en cours de drag.
     */
    val hoverInsertIndex by derivedStateOf {
        val colId = hoverColumnId ?: return@derivedStateOf -1
        val draggedId = draggingTaskId
        val cursorY = dragOffsetGlobal.y
        taskRects.entries
            .filter { (id, _) -> taskStatusOf[id] == colId && id != draggedId }
            .sortedBy { it.value.top }
            .count { (_, rect) -> (rect.top + rect.bottom) / 2f < cursorY }
    }
}

@Composable
internal fun KanbanBoard(
    project: Project,
    statuses: List<ProjectStatus>,
    tasks: List<Task>,
    repos: TeddRepositories,
    onOpenTask: (String) -> Unit,
    onNewStatus: () -> Unit,
    onEditStatus: (ProjectStatus) -> Unit,
    onDeleteStatus: (ProjectStatus) -> Unit,
    dragState: KanbanDragState,
) {
    val scope = rememberCoroutineScope()
    if (statuses.isEmpty()) {
        Box(modifier = Modifier.fillMaxSize().padding(TeddSpace.S8), contentAlignment = Alignment.TopCenter) {
            TeddEmptyState(
                title = "Aucune colonne",
                message = "Un tableau se lit de gauche à droite : à faire, en cours, terminé. Crée la première colonne.",
                icon = "grid",
                actionLabel = "Créer la première colonne",
                onAction = onNewStatus,
                modifier = Modifier.padding(top = TeddSpace.S8),
            )
        }
        return
    }

    // Hit-test on drag end : déplace la tâche vers la colonne survolée À LA POSITION
    // d'insertion calculée (entre les cards). Gère aussi le reorder dans la même colonne.
    fun handleDrop() {
        val id = dragState.draggingTaskId ?: return
        val targetStatus = dragState.hoverColumnId
        val task = tasks.firstOrNull { it.id == id }
        if (targetStatus != null && task != null) {
            val targetIndex = dragState.hoverInsertIndex.coerceAtLeast(0)
            // Tasks de la colonne cible, sortées, sans la tâche draggée
            val targetTasks = tasks
                .filter { it.status_id == targetStatus && it.id != id }
                .sortedBy { it.order_index }
            val newOrderIndex: Long = when {
                targetTasks.isEmpty() -> 1000L
                targetIndex <= 0 -> targetTasks.first().order_index - 1000L
                targetIndex >= targetTasks.size -> targetTasks.last().order_index + 1000L
                else -> {
                    val before = targetTasks[targetIndex - 1].order_index
                    val after = targetTasks[targetIndex].order_index
                    if (after - before > 1) (before + after) / 2L
                    else before + 1L  // fallback si collision
                }
            }
            // Skip si la position est inchangée (même colonne, même slot)
            val currentIndex = tasks
                .filter { it.status_id == task.status_id }
                .sortedBy { it.order_index }
                .indexOfFirst { it.id == id }
            val isSameSlot = task.status_id == targetStatus &&
                (currentIndex == targetIndex || currentIndex == targetIndex - 1)
            if (!isSameSlot) {
                scope.launch { repos.tasks.moveToStatus(id, targetStatus, newOrderIndex) }
            }
        }
        dragState.draggingTaskId = null
    }

    Row(
        modifier = Modifier
            .fillMaxSize()
            .horizontalScroll(rememberScrollState())
            .padding(start = TeddSpace.S8, end = TeddSpace.S8, top = TeddSpace.S3, bottom = TeddSpace.S6),
        horizontalArrangement = Arrangement.spacedBy(TeddSpace.S3),
    ) {
        statuses.forEach { status ->
            KanbanColumn(
                status = status,
                tasks = tasks.filter { it.status_id == status.id }.sortedBy { it.order_index },
                repos = repos,
                projectId = project.id,
                onOpenTask = onOpenTask,
                onEdit = { onEditStatus(status) },
                onDelete = { onDeleteStatus(status) },
                dragState = dragState,
                onDrop = ::handleDrop,
            )
        }

        // "+ Nouvelle colonne" affordance
        Box(
            modifier = Modifier
                .width(240.dp)
                .heightIn(min = 80.dp)
                .clip(RoundedCornerShape(TeddTokens.RMd))
                .border(1.5.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RMd))
                .clickable(
                    interactionSource = remember { MutableInteractionSource() },
                    indication = null,
                    onClick = onNewStatus,
                )
                .padding(vertical = 18.dp, horizontal = 12.dp),
            contentAlignment = Alignment.Center,
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(8.dp),
            ) {
                TeddIcon(name = "plus", size = 14.dp, color = TeddTokens.InkMuted)
                Text(
                    text = "Nouvelle colonne",
                    color = TeddTokens.InkMuted,
                    fontSize = 13.sp,
                    fontWeight = FontWeight.Medium,
                )
            }
        }
    }
}

@Composable
internal fun KanbanColumn(
    status: ProjectStatus,
    tasks: List<Task>,
    repos: TeddRepositories,
    projectId: String,
    onOpenTask: (String) -> Unit,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
    dragState: KanbanDragState,
    onDrop: () -> Unit,
) {
    val color = runCatching { Color(parseHexProj(status.color)) }.getOrElse { TeddTokens.LimeStrong }
    var addingTask by remember(status.id) { mutableStateOf(false) }
    var newTitle by remember(status.id) { mutableStateOf("") }
    val scope = rememberCoroutineScope()
    val isHover = dragState.hoverColumnId == status.id && dragState.draggingTaskId != null

    val terminal = status.is_terminal == 1L
    Column(
        modifier = Modifier
            .width(if (terminal) 232.dp else 286.dp)
            .heightIn(max = 800.dp)
            .clip(RoundedCornerShape(TeddTokens.RLg))
            .background(if (terminal) TeddTokens.Bg else TeddTokens.SurfaceSunken, RoundedCornerShape(TeddTokens.RLg))
            .then(
                when {
                    isHover -> Modifier.border(2.dp, color, RoundedCornerShape(TeddTokens.RLg))
                    terminal -> Modifier.border(1.5.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RLg))
                    else -> Modifier
                },
            )
            .onGloballyPositioned { coords ->
                val pos = coords.positionInRoot()
                dragState.columnRects[status.id] = Rect(
                    left = pos.x,
                    top = pos.y,
                    right = pos.x + coords.size.width,
                    bottom = pos.y + coords.size.height,
                )
            },
    ) {
        // Column header
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 12.dp, vertical = 10.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            Box(
                modifier = Modifier
                    .size(8.dp)
                    .clip(RoundedCornerShape(2.dp))
                    .background(color),
            )
            Text(text = status.name, color = TeddTokens.Ink, style = TeddType.Label)
            if (status.is_terminal == 1L) {
                Box(
                    modifier = Modifier
                        .clip(RoundedCornerShape(TeddTokens.RFull))
                        .background(TeddTokens.Success.copy(alpha = 0.12f), RoundedCornerShape(TeddTokens.RFull))
                        .padding(horizontal = 5.dp, vertical = 1.dp),
                ) {
                    TeddIcon(name = "check", size = 9.dp, color = TeddTokens.Success, strokeWidth = 2.5.dp)
                }
            }
            Text(
                text = "${tasks.size}",
                color = TeddTokens.InkMuted,
                fontSize = 11.sp,
                modifier = Modifier
                    .clip(RoundedCornerShape(TeddTokens.RFull))
                    .background(TeddTokens.Surface, RoundedCornerShape(TeddTokens.RFull))
                    .padding(horizontal = 7.dp, vertical = 1.dp),
            )
            Spacer(modifier = Modifier.weight(1f))
            ProjectMoreMenu(
                listOf(
                    MenuAction("Renommer la colonne", "edit", onEdit),
                    MenuAction("Supprimer la colonne", "trash", onDelete, danger = true),
                ),
                size = 24.dp,
            )
        }

        // Tasks
        Column(
            modifier = Modifier
                .verticalScroll(rememberScrollState())
                .padding(8.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            // Affiche un indicateur d'insertion à la position courante si on hover cette colonne
            val showInsert = isHover
            val insertIdx = if (showInsert) dragState.hoverInsertIndex else -1
            tasks.forEachIndexed { index, task ->
                if (showInsert && index == insertIdx && task.id != dragState.draggingTaskId) {
                    InsertionLine(color = color)
                }
                KanbanCard(
                    task = task,
                    statusColor = color,
                    dragState = dragState,
                    onClick = { onOpenTask(task.id) },
                    onDrop = onDrop,
                    onSendToPomodoro = {
                        scope.launch {
                            val today = org.teddapp.project.db.TODAY_ISO
                            val created = repos.pomodoro.addFromSource(today, "project_task", task.id)
                            if (created != null) repos.tasks.setPomodoroPool(task.id, today)
                        }
                    },
                )
            }
            if (showInsert && insertIdx >= tasks.count { it.id != dragState.draggingTaskId }) {
                InsertionLine(color = color)
            }
            if (addingTask) {
                // Saisie à la chaîne : Entrée ajoute et garde le champ ouvert, Échap le ferme.
                val focus = remember { androidx.compose.ui.focus.FocusRequester() }
                androidx.compose.runtime.LaunchedEffect(Unit) { focus.requestFocus() }
                val add: () -> Unit = {
                    val t = newTitle.trim()
                    if (t.isNotEmpty()) {
                        scope.launch {
                            repos.tasks.create(
                                parentKind = ParentKind.Project,
                                parentId = projectId,
                                statusId = status.id,
                                title = t,
                                orderIndex = tasks.size.toLong(),
                            )
                        }
                        newTitle = ""
                    }
                }
                val fieldShape = RoundedCornerShape(TeddTokens.RSm)
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(TeddTokens.Surface, fieldShape)
                        .border(1.dp, TeddTokens.Ink, fieldShape)
                        .padding(10.dp),
                    verticalArrangement = Arrangement.spacedBy(6.dp),
                ) {
                    BasicTextField(
                        value = newTitle,
                        onValueChange = { newTitle = it },
                        singleLine = true,
                        modifier = Modifier
                            .fillMaxWidth()
                            .focusRequester(focus)
                            .onPreviewKeyEvent { e ->
                                when {
                                    e.type != KeyEventType.KeyDown -> false
                                    e.key == Key.Escape -> { addingTask = false; newTitle = ""; true }
                                    e.key == Key.Enter || e.key == Key.NumPadEnter -> { add(); true }
                                    else -> false
                                }
                            },
                        textStyle = TeddType.Body.copy(color = TeddTokens.Ink),
                        cursorBrush = SolidColor(TeddTokens.Ink),
                        keyboardOptions = KeyboardOptions(imeAction = ImeAction.Done),
                        keyboardActions = KeyboardActions(onDone = { add() }),
                        decorationBox = { inner ->
                            if (newTitle.isEmpty()) Text("Titre de la tâche…", color = TeddTokens.InkSubtle, style = TeddType.Body)
                            inner()
                        },
                    )
                    Text("Entrée pour ajouter · Échap pour fermer", color = TeddTokens.InkMuted, style = TeddType.Caption.copy(fontSize = 11.sp))
                }
            } else {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .teddClickable(onClick = { addingTask = true; newTitle = "" })
                        .padding(horizontal = 10.dp, vertical = 8.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                ) {
                    TeddIcon(name = "plus", size = 14.dp, color = TeddTokens.InkMuted)
                    Text("Ajouter une tâche", color = TeddTokens.InkMuted, style = TeddType.Label)
                }
            }
        }
    }
}

@Composable
internal fun KanbanCard(
    task: Task,
    statusColor: Color,
    dragState: KanbanDragState,
    onClick: () -> Unit,
    onDrop: () -> Unit,
    onSendToPomodoro: (() -> Unit)? = null,
) {
    val prio = priorityColor(task.priority)
    val isDragging = dragState.draggingTaskId == task.id
    val density = LocalDensity.current
    var cardGlobalPos by remember { mutableStateOf(Offset.Zero) }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .onGloballyPositioned { coords ->
                cardGlobalPos = coords.positionInRoot()
                // Enregistre le rect global de la card pour le hit-test d'insertion.
                val pos = coords.positionInRoot()
                dragState.taskRects[task.id] = Rect(
                    left = pos.x,
                    top = pos.y,
                    right = pos.x + coords.size.width,
                    bottom = pos.y + coords.size.height,
                )
                task.status_id?.let { dragState.taskStatusOf[task.id] = it }
            }
            // IMPORTANT : pas de translation ici. Si la card bougeait visuellement, les
            // coords locales du pointerInput resteraient figées (la card suit le curseur)
            // et positionChange() retournerait zéro → le hit-test casse. À la place, on
            // fade simplement l'original et un ghost overlay (rendu plus haut dans l'arbre)
            // suit le curseur.
            .graphicsLayer { if (isDragging) alpha = 0.4f }
            .clip(RoundedCornerShape(TeddTokens.RSm))
            .background(TeddTokens.Surface, RoundedCornerShape(TeddTokens.RSm))
            .then(
                if (isDragging) Modifier.border(1.5.dp, statusColor, RoundedCornerShape(TeddTokens.RSm)) else Modifier,
            )
            // Click+drag disambiguation : si déplacement > touchSlop → drag, sinon click.
            .pointerInput(task.id) {
                val slop = viewConfiguration.touchSlop
                awaitEachGesture {
                    val down = awaitFirstDown(requireUnconsumed = false)
                    var dragStarted = false
                    val startLocal = down.position
                    try {
                        while (true) {
                            val event = awaitPointerEvent()
                            val change = event.changes.firstOrNull { it.id == down.id } ?: break
                            if (!change.pressed) {
                                // Ne pas ouvrir le détail si le tap a été consommé par un
                                // contrôle interne (ex. bouton « + » envoyer au focus).
                                if (!dragStarted && !change.isConsumed) onClick()
                                break
                            }
                            if (!dragStarted) {
                                val totalDistance = (change.position - startLocal).getDistance()
                                if (totalDistance > slop) {
                                    dragStarted = true
                                    dragState.draggingTaskId = task.id
                                    dragState.dragOffsetGlobal = cardGlobalPos + startLocal
                                }
                            }
                            if (dragStarted) {
                                val delta = change.positionChange()
                                dragState.dragOffsetGlobal += delta
                                change.consume()
                            }
                        }
                    } finally {
                        if (dragStarted) onDrop()
                    }
                }
            },
    ) {
        // La carte ne montre que ce qui aide à choisir : le titre, puis ce qui presse.
        Column(
            modifier = Modifier.padding(start = 12.dp, end = 8.dp, top = 10.dp, bottom = 10.dp),
            verticalArrangement = Arrangement.spacedBy(6.dp),
        ) {
            Row(verticalAlignment = Alignment.Top, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                Text(
                    text = task.title,
                    color = TeddTokens.Ink,
                    style = TeddType.Label.copy(fontSize = 14.sp, lineHeight = 20.sp),
                    modifier = Modifier.weight(1f).padding(top = 2.dp),
                )
                if (onSendToPomodoro != null) {
                    // Envoyer la tâche dans la liste Focus du jour.
                    TeddIconButton(onClick = onSendToPomodoro, size = 24.dp) {
                        TeddIcon(name = "focus", size = 14.dp, color = TeddTokens.InkMuted)
                    }
                }
            }
            if (!task.description.isNullOrBlank()) {
                Text(
                    text = task.description!!,
                    color = TeddTokens.InkMuted,
                    style = TeddType.Caption,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.padding(end = 4.dp),
                )
            }
            val high = task.priority == "high"
            val due = task.due_date?.takeIf { it.isNotBlank() }
            val late = due != null && due < TeddDates.todayIso && task.status != "done"
            val estimate = estimateLabel(task.estimated_minutes, task.real_minutes)
            val idle = daysSince(task.updated_at)
            val stale = idle >= STALE_DAYS && task.status != "done"
            if (high || due != null || estimate != null || stale) {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    // Seule la priorité haute se signale : dire « moyenne » sur chaque carte n'apprend rien.
                    if (high) TeddTag("Prioritaire", tone = TeddTagTone.Danger, dot = true)
                    if (due != null) {
                        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                            TeddIcon(name = if (late) "alert" else "calendar", size = 12.dp, color = if (late) TeddTokens.Warning else TeddTokens.InkMuted)
                            Text(
                                text = TeddDates.formatRelative(due) ?: due,
                                color = if (late) TeddTokens.Warning else TeddTokens.InkMuted,
                                style = TeddType.Caption,
                            )
                        }
                    }
                    if (estimate != null) Text(estimate, color = TeddTokens.InkMuted, style = TeddType.MonoSm.copy(fontSize = 11.sp))
                    if (stale) Text("$idle j sans mouvement", color = TeddTokens.InkMuted, style = TeddType.Caption)
                }
            }
        }
    }
}

// ──────────────────────────────────────────────────────────────────────
// Vue Liste
// ──────────────────────────────────────────────────────────────────────

private enum class ListScope(val label: String) { Open("À faire"), Done("Faites"), All("Toutes") }

/**
 * La liste : les tâches rangées par colonne, une ligne chacune. On coche pour terminer,
 * on tape pour ajouter ; le reste (déplacer, supprimer) est dans le menu de la ligne.
 */
@Composable
internal fun ProjectListView(
    statuses: List<ProjectStatus>,
    tasks: List<Task>,
    repos: TeddRepositories,
    onOpenTask: (String) -> Unit,
    projectId: String? = null,
    modifier: Modifier = Modifier.fillMaxSize(),
    /** Téléphone : le champ d'ajout prend sa ligne, les filtres passent dessous. */
    compact: Boolean = false,
) {
    val scope = rememberCoroutineScope()
    var listScope by remember { mutableStateOf(ListScope.Open) }
    var highOnly by remember { mutableStateOf(false) }
    var newTitle by remember(projectId) { mutableStateOf("") }

    val firstOpen = statuses.firstOrNull { it.is_terminal != 1L }
    val firstDone = statuses.firstOrNull { it.is_terminal == 1L }
    val shown = statuses.filter {
        when (listScope) {
            ListScope.Open -> it.is_terminal != 1L
            ListScope.Done -> it.is_terminal == 1L
            ListScope.All -> true
        }
    }
    val byStatus = remember(tasks, highOnly) {
        tasks.filter { !highOnly || it.priority == "high" }.sortedBy { it.order_index }.groupBy { it.status_id }
    }
    val add: () -> Unit = {
        val t = newTitle.trim()
        if (t.isNotEmpty() && projectId != null && firstOpen != null) {
            scope.launch {
                repos.tasks.create(
                    parentKind = ParentKind.Project,
                    parentId = projectId,
                    statusId = firstOpen.id,
                    title = t,
                    orderIndex = (byStatus[firstOpen.id]?.size ?: 0).toLong(),
                )
            }
            newTitle = ""
        }
    }

    Column(
        modifier = modifier.padding(horizontal = if (compact) TeddSpace.S4 else TeddSpace.S8).padding(top = TeddSpace.S3),
        verticalArrangement = Arrangement.spacedBy(TeddSpace.S4),
    ) {
        FlowRow(horizontalArrangement = Arrangement.spacedBy(TeddSpace.S3), verticalArrangement = Arrangement.spacedBy(TeddSpace.S3)) {
            if (projectId != null && firstOpen != null) {
                val fieldShape = RoundedCornerShape(TeddTokens.RSm)
                Row(
                    modifier = (if (compact) Modifier.fillMaxWidth() else Modifier.weight(1f))
                        .height(TeddSize.ControlMd)
                        .background(TeddTokens.Surface, fieldShape)
                        .border(1.dp, TeddTokens.LineStrong, fieldShape)
                        .padding(horizontal = TeddSpace.S3),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2),
                ) {
                    TeddIcon(name = "plus", size = 14.dp, color = TeddTokens.InkMuted)
                    BasicTextField(
                        value = newTitle,
                        onValueChange = { newTitle = it },
                        singleLine = true,
                        modifier = Modifier.weight(1f).onPreviewKeyEvent { e ->
                            if (e.type == KeyEventType.KeyDown && (e.key == Key.Enter || e.key == Key.NumPadEnter)) { add(); true } else false
                        },
                        textStyle = TeddType.Body.copy(color = TeddTokens.Ink),
                        cursorBrush = SolidColor(TeddTokens.Ink),
                        keyboardOptions = KeyboardOptions(imeAction = ImeAction.Done),
                        keyboardActions = KeyboardActions(onDone = { add() }),
                        decorationBox = { inner ->
                            if (newTitle.isEmpty()) {
                                Text(
                                    if (compact) "Ajouter une tâche dans « ${firstOpen.name} »" else "Ajouter une tâche dans « ${firstOpen.name} », puis Entrée",
                                    color = TeddTokens.InkSubtle, style = TeddType.Body, maxLines = 1, overflow = TextOverflow.Ellipsis,
                                )
                            }
                            inner()
                        },
                    )
                }
            } else {
                Spacer(modifier = Modifier.weight(1f))
            }
            TeddTabs(
                modifier = Modifier.align(Alignment.CenterVertically),
                tabs = ListScope.entries.map { TeddTab(it.name, it.label) },
                selected = listScope.name,
                onSelect = { name -> ListScope.entries.firstOrNull { it.name == name }?.let { listScope = it } },
            )
            TeddCheckboxRow(label = "Prioritaires", checked = highOnly, onCheckedChange = { highOnly = it }, modifier = Modifier.align(Alignment.CenterVertically))
        }

        val nothing = shown.all { byStatus[it.id].isNullOrEmpty() }
        if (nothing) {
            TeddEmptyState(
                title = when {
                    tasks.isEmpty() -> "Aucune tâche"
                    highOnly -> "Aucune tâche prioritaire ici"
                    listScope == ListScope.Done -> "Rien de terminé pour l'instant"
                    else -> "Tout est fait"
                },
                message = if (tasks.isEmpty()) "Écris la première dans le champ ci-dessus." else null,
                icon = "check",
                modifier = Modifier.fillMaxWidth().padding(top = TeddSpace.S8),
            )
        } else {
            LazyColumn(
                modifier = Modifier.fillMaxSize(),
                verticalArrangement = Arrangement.spacedBy(TeddSpace.S5),
                contentPadding = PaddingValues(bottom = TeddSpace.S12),
            ) {
                items(shown, key = { it.id }) { status ->
                    val rows = byStatus[status.id].orEmpty()
                    if (rows.isNotEmpty()) {
                        val color = runCatching { Color(parseHexProj(status.color)) }.getOrElse { TeddTokens.InkMuted }
                        Column(verticalArrangement = Arrangement.spacedBy(TeddSpace.S2)) {
                            Row(
                                modifier = Modifier.padding(horizontal = TeddSpace.S1),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2),
                            ) {
                                Box(modifier = Modifier.size(8.dp).background(color, RoundedCornerShape(2.dp)))
                                Text(status.name, color = TeddTokens.Ink, style = TeddType.Label)
                                Text("${rows.size}", color = TeddTokens.InkMuted, style = TeddType.MonoSm.copy(fontSize = 11.sp))
                            }
                            Column(modifier = Modifier.fillMaxWidth().teddSurface(RoundedCornerShape(TeddTokens.RMd))) {
                                rows.forEachIndexed { index, task ->
                                    if (index > 0) Box(Modifier.fillMaxWidth().height(1.dp).background(TeddTokens.Line))
                                    ProjectListRow(
                                        task = task,
                                        status = status,
                                        statuses = statuses,
                                        onOpen = { onOpenTask(task.id) },
                                        onChangeStatus = { newStatusId ->
                                            scope.launch { repos.tasks.moveToStatus(task.id, newStatusId, task.order_index) }
                                        },
                                        onDelete = { scope.launch { repos.tasks.softDelete(task.id) } },
                                        onSendToPomodoro = {
                                            scope.launch {
                                                val today = org.teddapp.project.db.TODAY_ISO
                                                val created = repos.pomodoro.addFromSource(today, "project_task", task.id)
                                                if (created != null) repos.tasks.setPomodoroPool(task.id, today)
                                            }
                                        },
                                        doneStatusId = firstDone?.id,
                                        openStatusId = firstOpen?.id,
                                        compact = compact,
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

/** Une tâche en ligne : la case pour la terminer, le titre, ce qui presse, puis Focus et le menu. */
@Composable
internal fun ProjectListRow(
    task: Task,
    status: ProjectStatus?,
    statuses: List<ProjectStatus>,
    onOpen: () -> Unit,
    onChangeStatus: (String) -> Unit,
    onDelete: () -> Unit,
    onSendToPomodoro: (() -> Unit)? = null,
    doneStatusId: String? = null,
    openStatusId: String? = null,
    /** Téléphone : le titre garde toute la largeur, ce qui presse passe dessous. */
    compact: Boolean = false,
) {
    val done = status?.is_terminal == 1L
    val due = task.due_date?.takeIf { it.isNotBlank() }
    val late = due != null && due < TeddDates.todayIso && !done
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .teddClickable(onClick = onOpen, shape = RoundedCornerShape(0.dp), role = null)
            .padding(start = TeddSpace.S4, end = TeddSpace.S2, top = TeddSpace.S2, bottom = TeddSpace.S2),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(TeddSpace.S3),
    ) {
        // Cocher range la tâche dans la colonne terminale ; décocher la remet dans la première colonne ouverte.
        if (doneStatusId != null && openStatusId != null) {
            TeddCheckbox(checked = done, onCheckedChange = { onChangeStatus(if (it) doneStatusId else openStatusId) })
        }
        val high = task.priority == "high" && !done
        val urgency: @Composable () -> Unit = {
            if (high) TeddTag("Prioritaire", tone = TeddTagTone.Danger, dot = true)
            if (due != null) {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                    TeddIcon(name = if (late) "alert" else "calendar", size = 12.dp, color = if (late) TeddTokens.Warning else TeddTokens.InkMuted)
                    Text(TeddDates.formatRelative(due) ?: due, color = if (late) TeddTokens.Warning else TeddTokens.InkMuted, style = TeddType.Caption)
                }
            }
        }
        Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(4.dp)) {
            Text(
                text = task.title,
                color = if (done) TeddTokens.InkMuted else TeddTokens.Ink,
                style = TeddType.Body.copy(textDecoration = if (done) androidx.compose.ui.text.style.TextDecoration.LineThrough else null),
                maxLines = if (compact) 2 else 1,
                overflow = TextOverflow.Ellipsis,
            )
            if (compact && (high || due != null)) {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2)) { urgency() }
            }
        }
        if (!compact) urgency()
        if (onSendToPomodoro != null && !done) {
            TeddIconButton(onClick = onSendToPomodoro, size = 28.dp) {
                TeddIcon(name = "focus", size = 14.dp, color = TeddTokens.InkMuted)
            }
        }
        ProjectMoreMenu(
            actions = statuses.filter { it.id != status?.id }.map { s -> MenuAction("Déplacer vers ${s.name}", "arrow-right", { onChangeStatus(s.id) }) } +
                MenuAction("Supprimer la tâche", "trash", onDelete, danger = true),
            size = 28.dp,
        )
    }
}

/**
 * Ligne d'insertion entre deux cards quand on hover une colonne pendant le drag.
 * 2dp tall, colorée par la couleur du statut, avec une point lumineuse à gauche.
 */
@Composable
internal fun InsertionLine(color: Color) {
    Row(
        modifier = Modifier.fillMaxWidth().height(8.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(4.dp),
    ) {
        Box(
            modifier = Modifier
                .size(6.dp)
                .clip(CircleShape)
                .background(color),
        )
        Box(
            modifier = Modifier
                .weight(1f)
                .height(2.dp)
                .clip(RoundedCornerShape(1.dp))
                .background(color),
        )
    }
}

// ──────────────────────────────────────────────────────────────────────
// Ghost card overlay
// ──────────────────────────────────────────────────────────────────────
@Composable
internal fun DragGhostOverlay(
    dragState: KanbanDragState,
    project: Project,
    repos: TeddRepositories,
) {
    val tasks by repos.tasks.observeByProject(project.id).collectAsState(emptyList())
    val statuses by repos.projectStatus.observeByProject(project.id).collectAsState(emptyList())

    val draggedId = dragState.draggingTaskId ?: return
    val task = tasks.firstOrNull { it.id == draggedId } ?: return
    val status = statuses.firstOrNull { it.id == task.status_id }
    val statusColor = status?.color?.let { runCatching { Color(parseHexProj(it)) }.getOrNull() }
        ?: TeddTokens.LimeStrong
    val prio = priorityColor(task.priority)

    val density = LocalDensity.current
    val ghostWidthDp = 260.dp
    val xOffsetPx = with(density) { (ghostWidthDp / 2).toPx() }
    val yOffsetPx = with(density) { 20.dp.toPx() }

    Box(
        modifier = Modifier
            .width(ghostWidthDp)
            .offset {
                IntOffset(
                    (dragState.dragOffsetGlobal.x - xOffsetPx).roundToInt(),
                    (dragState.dragOffsetGlobal.y - yOffsetPx).roundToInt(),
                )
            }
            .graphicsLayer {
                rotationZ = -3f
                shadowElevation = with(density) { 18.dp.toPx() }
                alpha = 0.95f
            }
            .clip(RoundedCornerShape(TeddTokens.RSm))
            .background(TeddTokens.Surface, RoundedCornerShape(TeddTokens.RSm))
            .border(2.dp, statusColor, RoundedCornerShape(TeddTokens.RSm)),
    ) {
        Row {
            // Priority stripe
            Box(modifier = Modifier.width(3.dp).heightIn(min = 40.dp).background(prio))
            Column(modifier = Modifier.padding(10.dp)) {
                Text(
                    text = task.title,
                    color = TeddTokens.Ink,
                    fontSize = 13.sp,
                    fontWeight = FontWeight.SemiBold,
                    maxLines = 2,
                )
                Spacer(modifier = Modifier.height(6.dp))
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                    TeddChip(
                        text = priorityLabel(task.priority),
                        color = prio,
                        tone = ChipTone.Soft,
                        size = ChipSize.Sm,
                    )
                    if (!task.due_date.isNullOrBlank()) {
                        Text(TeddDates.formatRelative(task.due_date) ?: task.due_date!!, color = TeddTokens.InkMuted, fontSize = 11.sp)
                    }
                }
            }
        }
    }
}

// ──────────────────────────────────────────────────────────────────────
// Détail d'une tâche, en panneau latéral
// ──────────────────────────────────────────────────────────────────────

/**
 * Tout ce qu'on sait d'une tâche, modifiable sur place. Chaque changement est enregistré
 * aussitôt : il n'y a rien à valider, on ferme quand on a fini.
 */
@Composable
internal fun TaskDetailPanel(
    task: Task,
    statuses: List<ProjectStatus>,
    onClose: () -> Unit,
    onUpdate: (title: String, description: String, statusId: String?, priority: String?, dueDate: String) -> Unit,
    onDelete: () -> Unit,
    /** Panneau latéral sur ordinateur ; plein écran sur téléphone. */
    modifier: Modifier = Modifier.width(TeddSize.SidePanel).fillMaxHeight(),
    compact: Boolean = false,
) {
    var title by remember(task.id) { mutableStateOf(task.title) }
    var description by remember(task.id) { mutableStateOf(task.description ?: "") }
    var statusId by remember(task.id) { mutableStateOf(task.status_id) }
    var priority by remember(task.id) { mutableStateOf(task.priority ?: "medium") }
    var dueDate by remember(task.id) { mutableStateOf(task.due_date ?: "") }

    Row(modifier = modifier) {
        Box(Modifier.width(1.dp).fillMaxHeight().background(TeddTokens.Line))
        Column(
            modifier = Modifier
                .fillMaxSize()
                .background(TeddTokens.Bg)
                // Un clic dans le panneau ne doit pas atteindre le voile derrière lui.
                .clickable(interactionSource = remember { MutableInteractionSource() }, indication = null, onClick = {}),
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().padding(start = TeddSpace.S6, end = TeddSpace.S4, top = TeddSpace.S4, bottom = TeddSpace.S2),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Text("TÂCHE", color = TeddTokens.InkMuted, style = TeddType.Overline, modifier = Modifier.weight(1f))
                TeddIconButton(onClick = onClose) { TeddIcon(name = "x", size = 16.dp, color = TeddTokens.InkMuted) }
            }

            Column(
                modifier = Modifier
                    .weight(1f)
                    .verticalScroll(rememberScrollState())
                    .padding(horizontal = TeddSpace.S6, vertical = TeddSpace.S2),
                verticalArrangement = Arrangement.spacedBy(TeddSpace.S6),
            ) {
                BasicTextField(
                    value = title,
                    onValueChange = { title = it; onUpdate(it, description, statusId, priority, dueDate) },
                    modifier = Modifier.fillMaxWidth(),
                    textStyle = TeddType.Title2.copy(color = TeddTokens.Ink),
                    cursorBrush = SolidColor(TeddTokens.Ink),
                    decorationBox = { inner ->
                        if (title.isEmpty()) Text("Titre de la tâche", color = TeddTokens.InkSubtle, style = TeddType.Title2)
                        inner()
                    },
                )

                DetailField("Colonne") {
                    FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                        statuses.forEach { s ->
                            val sColor = runCatching { Color(parseHexProj(s.color)) }.getOrElse { TeddTokens.InkMuted }
                            val selected = statusId == s.id
                            val shape = RoundedCornerShape(TeddTokens.RFull)
                            Row(
                                modifier = Modifier
                                    .border(1.dp, if (selected) TeddTokens.Ink else TeddTokens.Line, shape)
                                    .teddClickable(
                                        onClick = { statusId = s.id; onUpdate(title, description, s.id, priority, dueDate) },
                                        shape = shape,
                                        fill = if (selected) TeddTokens.Surface else Color.Transparent,
                                    )
                                    .height(30.dp)
                                    .padding(horizontal = TeddSpace.S3),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.spacedBy(6.dp),
                            ) {
                                Box(modifier = Modifier.size(8.dp).background(sColor, CircleShape))
                                Text(
                                    s.name,
                                    color = if (selected) TeddTokens.Ink else TeddTokens.InkMuted,
                                    style = TeddType.Caption.copy(fontWeight = FontWeight(if (selected) 600 else 450)),
                                    maxLines = 1,
                                )
                            }
                        }
                    }
                }

                FlowRow(horizontalArrangement = Arrangement.spacedBy(TeddSpace.S4), verticalArrangement = Arrangement.spacedBy(TeddSpace.S6)) {
                    DetailField("Priorité") {
                        TeddTabs(
                            tabs = listOf("low", "medium", "high").map { TeddTab(it, priorityLabel(it)) },
                            selected = priority,
                            onSelect = { priority = it; onUpdate(title, description, statusId, it, dueDate) },
                        )
                    }
                    DetailField("Échéance", modifier = if (compact) Modifier.fillMaxWidth() else Modifier.weight(1f)) {
                        TeddDateField(
                            label = null,
                            value = dueDate,
                            onValueChange = { dueDate = it; onUpdate(title, description, statusId, priority, it) },
                            height = 38.dp,
                        )
                    }
                }

                DetailField("Description") {
                    val shape = RoundedCornerShape(TeddTokens.RSm)
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .heightIn(min = 120.dp)
                            .background(TeddTokens.Surface, shape)
                            .border(1.dp, TeddTokens.LineStrong, shape)
                            .padding(TeddSpace.S3),
                    ) {
                        BasicTextField(
                            value = description,
                            onValueChange = { description = it; onUpdate(title, it, statusId, priority, dueDate) },
                            modifier = Modifier.fillMaxWidth(),
                            textStyle = TeddType.Body.copy(color = TeddTokens.Ink),
                            cursorBrush = SolidColor(TeddTokens.Ink),
                            decorationBox = { inner ->
                                if (description.isEmpty()) Text("Ce qu'il faut faire, ce qui bloque, un lien…", color = TeddTokens.InkSubtle, style = TeddType.Body)
                                inner()
                            },
                        )
                    }
                }
            }

            Box(Modifier.fillMaxWidth().height(1.dp).background(TeddTokens.Line))
            Row(
                modifier = Modifier.fillMaxWidth().padding(horizontal = TeddSpace.S4, vertical = TeddSpace.S3),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2),
            ) {
                TeddButton(text = "Supprimer", onClick = onDelete, kind = TeddButtonKind.Ghost, icon = "trash")
                Spacer(modifier = Modifier.weight(1f))
                if (!compact) Text("Enregistré au fil de la saisie", color = TeddTokens.InkMuted, style = TeddType.Caption)
                TeddButton(text = "Fermer", onClick = onClose, kind = TeddButtonKind.Primary)
            }
        }
    }
}

@Composable
private fun DetailField(label: String, modifier: Modifier = Modifier, content: @Composable () -> Unit) {
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(6.dp)) {
        Text(label, color = TeddTokens.Ink, style = TeddType.Label)
        content()
    }
}

// ──────────────────────────────────────────────────────────────────────
// Aucun projet choisi
// ──────────────────────────────────────────────────────────────────────
@Composable
internal fun ProjectsEmptyState() {
    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        TeddEmptyState(
            title = "Aucun projet ouvert",
            message = "Choisis un projet dans la colonne de gauche, ou crée-en un.",
            icon = "grid",
        )
    }
}

// ──────────────────────────────────────────────────────────────────────
// Helpers
// ──────────────────────────────────────────────────────────────────────
@Composable
@ReadOnlyComposable
internal fun priorityColor(p: String?): Color = when (p) {
    "high" -> TeddTokens.Danger
    "medium" -> TeddTokens.Warning
    "low" -> TeddTokens.InkMuted
    else -> TeddTokens.InkSubtle
}

internal fun priorityLabel(p: String?): String = when (p) {
    "high"   -> "Haute"
    "medium" -> "Moyenne"
    "low"    -> "Basse"
    else     -> "—"
}

internal fun parseHexProj(hex: String): Long {
    val clean = hex.trimStart('#')
    val rgb = clean.toLong(16)
    return 0xFF000000L or rgb
}

/**
 * La compétence du projet, visible dans l'en-tête : le temps passé ici compte dans ses heures.
 * Sans compétence, une invitation discrète à en rattacher une.
 */
@Composable
internal fun ProjectSkillTag(skill: Skill?, onClick: () -> Unit) {
    if (skill == null) {
        Text(
            text = "Aucune compétence",
            color = TeddTokens.InkMuted,
            fontSize = 12.sp,
            modifier = Modifier
                .clip(RoundedCornerShape(TeddTokens.RFull))
                .clickable(interactionSource = remember { MutableInteractionSource() }, indication = null, onClick = onClick)
                .padding(horizontal = 8.dp, vertical = 3.dp),
        )
        return
    }
    val c = runCatching { Color(parseHexProj(skill.color)) }.getOrElse { TeddTokens.LimeStrong }
    Row(
        modifier = Modifier
            .clip(RoundedCornerShape(TeddTokens.RFull))
            .background(c.copy(alpha = 0.13f), RoundedCornerShape(TeddTokens.RFull))
            .clickable(interactionSource = remember { MutableInteractionSource() }, indication = null, onClick = onClick)
            .padding(horizontal = 9.dp, vertical = 3.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(5.dp),
    ) {
        TeddIcon(name = skill.icon, size = 11.dp, color = c, strokeWidth = 2.dp)
        Text(skill.name, color = c, fontSize = 12.sp, fontWeight = FontWeight.SemiBold)
    }
}
